import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import DashboardService from '../../../core/service'

export const getVSIC = createAsyncThunk(
  'dashboard/creditRisk/getVSIC',
  async (params, { rejectWithValue }) => {
    try {
      const res = await DashboardService.getVSIC(params)
      if (res.success) {
        return res.data
      }
      return rejectWithValue({ loading: false })
    } catch (err) {
      if (axios.isCancel(err)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getRiskDistribution = createAsyncThunk(
  'dashboard/creditRisk/getRiskDistribution',
  async (params, { rejectWithValue }) => {
    try {
      const res = await DashboardService.getRiskDistribution(params)
      if (res.success) {
        return res
      }
      return rejectWithValue({ loading: false })
    } catch (err) {
      if (axios.isCancel(err)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)
